import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template"];

  add(event) {
    event.preventDefault();

    const item = this.hasTemplateTarget
      ? this.templateTarget.content.firstElementChild.cloneNode(true)
      : this.cloneItem(this.items[0]);

    this.listElement.append(item);
    this.toggleRemoveButtons();
    item.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  remove(event) {
    event.preventDefault();

    const item = event.target.closest(this.itemSelector);
    const destroyField = item.querySelector(this.destroyFieldSelector);

    if (destroyField) {
      destroyField.value = 1;
      item.classList.add("hidden");

      item.querySelectorAll("input, select, textarea").forEach((input) => {
        input.removeAttribute("required");
      });
    } else {
      item.remove();
    }

    this.toggleRemoveButtons();
  }

  cloneItem(item) {
    const container = document.createElement("div");
    container.innerHTML = item.outerHTML;

    const clonedItem = container.children[0];
    const preserveFields = [
      ...clonedItem.querySelectorAll(this.preserveFieldSelector),
    ];

    clonedItem.querySelectorAll("input, select").forEach((field) => {
      if (!preserveFields.includes(field)) {
        field.value = "";
      }
    });

    const positionField = clonedItem.querySelector(this.positionFieldSelector);
    if (positionField) {
      positionField.value = this.items.length;
    }

    return clonedItem;
  }

  toggleRemoveButtons() {
    const hideRemoveButtons = this.visibleItems.length < 2;

    this.items.forEach((item) => {
      item
        .querySelector(this.removeButtonSelector)
        ?.classList.toggle("hidden", hideRemoveButtons);
    });
  }

  get listElement() {
    return this.hasListTarget ? this.listTarget : this.element;
  }

  get items() {
    return [...this.listElement.children].filter((element) =>
      element.matches(this.itemSelector),
    );
  }

  get visibleItems() {
    return this.items.filter((item) => !item.classList.contains("hidden"));
  }

  get itemSelector() {
    return "[data-list-inputs-target~='item']";
  }

  get removeButtonSelector() {
    return "[data-list-inputs-target~='removeButton']";
  }

  get destroyFieldSelector() {
    return "[data-list-inputs-target~='destroyField']";
  }

  get preserveFieldSelector() {
    return "[data-list-inputs-target~='preserveField']";
  }

  get positionFieldSelector() {
    return "[data-list-inputs-target~='positionField']";
  }
}
